import noop from 'lodash/fp/noop';
import React, { type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { type ConnectedProps, connect } from 'react-redux';

import { searchActions } from '../../application/redux/search/searchReducer';
import { gaPush, TRACKING_CATEGORIES } from '../../configuration/setup/googleTagManager';
import type { AppDispatch, RootState } from '../../configuration/setup/store';

export const WaypointsOptions: FunctionComponent<WaypointsOptionsProps> = React.memo(props => {
    const { waypointsOrderInverted = noop, waypointAdded = noop } = props;

    const handleInvertOrderButton = () => {
        waypointsOrderInverted();
        gaPush({
            category: TRACKING_CATEGORIES.WAYPOINT_EDITOR,
            action: 'Invert Waypoint Order Clicked',
            label: 'Clicked Invert Waypoint Order',
        });
    };

    const handleAddDestination = () => {
        waypointAdded();
        gaPush({
            category: TRACKING_CATEGORIES.WAYPOINT_EDITOR,
            action: 'Add Destination Clicked',
            label: 'Add Destination Button',
        });
    };

    return (
        <div className={'InvertWaypoints display-flex align-items-center justify-content-between'}>
            <button
                type='button'
                className={'btn btn-sm btn-link btn-link-inline margin-left-0 text-color-dark'}
                onClick={handleAddDestination}
            >
                <span className={'uikit-icon icon-plus-sign text-color-dark margin-right-5'} />
                <FormattedMessage id={'intl-msg:routeplanning.addDestination'} />
            </button>
            <button className={'btn btn-muted btn-icon-only'} type={'button'} onClick={handleInvertOrderButton}>
                <span className={'uikit-icon icon-sort'} />
            </button>
        </div>
    );
});

type WaypointsOptionsProps = ConnectedProps<typeof connector>;

export const mapStateToProps = (state: RootState) => ({});

export const mapDispatchToProps = (dispatch: AppDispatch) => ({
    waypointsOrderInverted: () => {
        dispatch(searchActions.waypointsOrderInverted());
    },
    waypointAdded: () => {
        dispatch(searchActions.waypointAdded(-1));
    },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export const WaypointsOptionsContainer = connector(WaypointsOptions);
